import { useState } from "react";

import { useDiscoverContext } from "@/components/app/discover/discover-context";
import { DiscoverMainFilter } from "@/components/app/discover/discover-main-filter";
import { EmptyState } from "@/components/shared/empty-state";
import { cn } from "@/utils/lib";

import { BaseTile } from "../base-tile";
import type { useTokenMetrics } from "../use-token-metrics";
import { LaunchedTileExtraContent } from "./launched-tile-extra-content";
import { LaunchedTokenDetails } from "./launched-token-details";

export const LaunchedTokenTab = () => {
  const [selectedTokenMetrics, setSelectedTokenMetrics] = useState<ReturnType<
    typeof useTokenMetrics
  > | null>(null);

  const {
    creators: coins,
    pinnedCreators,
    lazyLoadingMarkup,
    initialLoading,
  } = useDiscoverContext();

  const hasResults = coins.length > 0;

  return (
    <>
      <div className="mt-4 flex size-full border-y border-border-light px-2">
        <DiscoverMainFilter isTimePeriodDisabled />
      </div>
      <div className="relative flex h-full min-h-lvh flex-row">
        <div
          className={cn("flex w-full flex-col gap-6 p-6 py-6", {
            "border-r border-border-light sm:w-7/12": hasResults,
          })}
        >
          {!initialLoading &&
            [...pinnedCreators, ...coins].map((creator, index) => (
              <BaseTile
                key={creator.publicKeyBase58Check}
                index={index}
                onClick={(x) => setSelectedTokenMetrics(x)}
                creator={creator}
                selectedTokenMetrics={selectedTokenMetrics}
                isSelected={
                  selectedTokenMetrics?.selectedPublicKey ===
                  creator.publicKeyBase58Check
                }
                extraContent={
                  <LaunchedTileExtraContent
                    publicKey={creator.publicKeyBase58Check}
                  />
                }
              />
            ))}
          {lazyLoadingMarkup}
          {!hasResults && !initialLoading && (
            <div className="flex size-full items-center justify-center p-2 py-4">
              <EmptyState
                image="/assets/empty-31.png"
                title="No results."
                description="Try adjusting the filters."
              />
            </div>
          )}
        </div>
        {hasResults && <LaunchedTokenDetails metrics={selectedTokenMetrics} />}
      </div>
    </>
  );
};
